import { render, staticRenderFns } from "./CategoryCreateTranslation.vue?vue&type=template&id=d456a704&"
import script from "./CategoryCreateTranslation.vue?vue&type=script&lang=js&"
export * from "./CategoryCreateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCreateTranslation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CategoryCreateTranslation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports